class GraphicSearch {
	constructor() {
		this._http = getAjaxObject();
		this._http.onload = this.append.bind(this);
		this._page = 0;

		this._onSelect = null;

		this._dialog = Dialog.Modal('graphic-search', _("Graphic Search"), X_LARGE, null, [
			this._results = div(),
			this._getMore = div('row text-center', [
				btn('btn', _("LOAD MORE"), {
					'click': this.loadMore.bind(this)
				})
			])
		]);
		this._dialog.head = div('row', [
			div('col-6', [
				this._searchText = text('form-control', null, {
					'keyup': this.type.bind(this),
					'paste': this.paste.bind(this)
				}, {
					'placeholder': _("Enter keywords for search"),
				})
			]),
			div('col-auto ms-auto', [
				this._uploadBtn = btn('btn tooltip', _("UPLOAD"), {
					'click': this.upload.bind(this)
				}, {
					'data-tip': _("Upload your own graphic")
				})
			])
		]);
		this._dialog.foot = btn('btn', _("NO GRAPHIC"), {
			'click': () => this.select(0)
		});
	}

	start(initialText, onSelect) {
		this._onSelect = onSelect;
		this._searchText.value = initialText || '';
		this._dialog.open();
		this.clear();
		this.search(initialText);
		this._searchText.select();
	}

	type() {
		this.clear();
		this.search(this._searchText.value);
	}

	paste(ev) {
		if (ev.clipboardData.getData('text').length == 0) return;
		this.clear();
		this.search(ev.clipboardData.getData('text'));
	}

	loadMore(){
		this._page++;
		this.search(this._searchText.value);
	}

	clear() {
		this._page = 0;
		this._results.innerHTML = '';
	}

	search(text) {
		if(this._http.readyState < 4) this._http.abort();
		let params = new URLSearchParams();
		params.append('s', text);
		params.append('p', this._page);
		
		this._http.open('GET', '/api/graphics?' + params.toString());
		this._http.send();
	}

	append() {
		let data = JSON.parse(this._http.responseText);
		if (Array.isArray(data)) {
			this._getMore.style.display = data.length < 12 ? 'none' : 'block';
			data.forEach(id => {
				this._results.appendChild(GraphicCard.fromId(id, this));
			}, this); 
		}
	}

	select(id) {
		if (id === null) return;
		if (this._onSelect !== null) {
			this._onSelect(id);
		}
		this._onSelect = null;
		this._dialog.close();
	}

	upload() {
		gUpload.open(this.select.bind(this), this._searchText.value);
	}
}